import axios from "../../axios-auth";
import qs from "qs";
import * as R from "ramda";
import { getMediaUrl } from "../../helpers/helpers";

const state = {
  defaults: {
    oieContainer: "#oie-container",
    editor: "#canvasArea",
    format: "#format-layer",
    marginViewPlaceHolder: ".marginViewPlaceHolder",
    generate: "#generatePdf",
    carousel: "#lpf_gallery_carousel",
    next: "#lfp_gallery_next",
    prev: "#lfp_gallery_prev",
    galleryItem: "#lpf_gallery_carousel .image_gallery_item",
    mirroredMargins: {
      top: ".marginViewPlaceHolder .topMirrored",
      bottom: ".marginViewPlaceHolder .bottomMirrored",
      left: ".marginViewPlaceHolder .leftMirrored",
      right: ".marginViewPlaceHolder .rightMirrored"
    },
    formatCropLayer: "#format-crop-layer",
    detectable:
      "#product_addtocart_form #product_part_container select.print_options",
    monochromatic_container: "#margin_color_container",
    monochromatic_input: "#margin_color_input",
    rounded_container: "#rounded_container",
    is_rotated_input: "#is_rotated_input",
    check_monochromatic: 0,
    addToCartButton: ".button.btn-cart",
    steckdosenEditor: "#steckdosenEditor",
    onlineEditor: "#onlineEditor",
    pdfImageDefault: {
      filename: "",
      path: "",
      cropX: 0,
      cropY: 0,
      cropX1: 0,
      cropY1: 0,
      cropH: 0,
      cropW: 0,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      type: "normal",
      circle_distance: 0,
      rotate_angle: 0
    },
    imageLayer: "#image-layer"
  },
  PoieVariables: {
    Texts: {
      generalError: "",
      invalidDim: "",
      customFormat: {
        label: "Custom Format",
        cm: "cm",
        formatText: "Format",
        widthEmpty: "Please input a width!",
        widthNumber: "Width must	be a number!",
        widthHigher: "Width must be smaller than %value%!",
        widthLower: "Width must be greater than %value%!",
        heightEmpty: "Please input a height!",
        heightNumber: "Height must be a number!",
        heightHigher: "Height must be smaller than %value%!",
        heightLower: "Height must be greater than %value%!",
        cannotChangeFormat: "You cannont change the format",
        alreadyExistFormat: "Format already exist!"
      },
      steckdosen: {
        remove: "Are you sure you want to delete this?",
        exists: "This dosen already exist!"
      },
      margins: {
        negativeValue: "Invalid Margin"
      },
      deleteMessage: "Are you sure you want to delete this item?"
    },
    defaults: {
      imageId: "2fac60ae91cdeb39060f5775524a7d04"
    },
    cmToInch: 0.393700787,
    cmToPt: 28.34645669291,
    pxToPt: 0.75,
    ppiQuality: [72, 150, 300, 400, 500],
    allowCustomFormat: 1,
    enableSteckdosen: 0,
    enableCorners: 0,
    enableCutouts: 0,
    splitOiePdf: 0,
    steckdosenLimits: [
      [10, 10, 10, 10],
      [10, 10, 10, 10],
      [10, 10, 10, 10]
    ],
    dosenSizes: [40, 76, 111],
    dosenIconSizes: [40, 40, 40],
    dosenFullWidth: [8, 15.2, 22.2],
    dosenFullHeight: [8, 8, 8, 8]
  },
  activeElement: {
    index: 0,
    type: "main"
  },
  ready: 0,
  showDosen: 1,
  editor: {
    width: null,
    height: null,
    dim: {
      imageDimByFormat: {
        width: null,
        height: null,
        width_cm: null,
        height_cm: null,
        unit: 1
      },
      canvasDimByFormat: {
        width: null,
        height: null,
        width_fix: null,
        height_fix: null,
        left: null,
        unit: 1
      },
      canvasImageDimByFormat: {
        width: null,
        height: null,
        left: null,
        top: null,
        right: null,
        bottom: null
      },
      canvasFormatDimByFormat: {
        width: null,
        height: null,
        width_fix: null,
        height_fix: null,
        left: null,
        top: null,
        bottom: null,
        right: null
      }
    },
    marginView: false,
    rotateAngle: 0,
    zoom: 100,
    focalPoint: {
      x: 0,
      y: 0
    },
    cropMode: 0,
    bckMode: 0
  },
  format: {
    width: 90,
    height: 30,
    type: 1, // 1-horizontal; 2-vertical
    rounded: 0,
    show: 1,
    split: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    type: 1, //-1 => inner(enlarged), +1 => outer(mirrored)
    lastChanged: "top",
    subtype: 1, // 1=mirrored, 2-white, 3-monocromatic
    rand_option: 0,
    topDefault: 0,
    rightDefault: 0,
    bottomDefault: 0,
    rightDefault: 0,
    color: "#ffffff"
  },
  object: {
    defaults: {
      movable: 1,
      resizable: 1,
      rotatable: 1,
      hasSnap: 0,
      angle: 0,
      offsetX: 0,
      offsetY: 0,
      imagePath: "",
      relativePath: "",
      relativeSrc: "",
      imageSrc: "",
      elementType: "object",
      ratioWidth: 1,
      ratioHeight: 1,
      itemType: "",
      isPdf: 0,
      name: ""
    },
    objects: []
  },
  corners: { corners: [] },
  cutouts: {
    defaults: {
      movable: 1,
      resizable: 0,
      hasSnap: 0,
      rotatable: 0,
      angle: 0,
      offsetX: 5,
      offsetY: 5,
      imagePath: "",
      relativePath: "",
      relativeSrc: "/media/personalization/cutouts/",
      imageSrc: "",
      width: 10,
      height: 10,
      name: ""
    },

    cutouts: []
  },
  sockets: {},
  steckdosen: {
    defaults: {
      movable: 1,
      resizable: 0,
      hasSnap: 0,
      rotatable: 0,
      angle: 0,
      offsetX: 4,
      offsetY: 4,
      imagePath: "",
      relativePath: "",
      relativeSrc: "/media/personalization/sockets/",
      imageSrc: "",
      name: ""
    },
    dosens: []
  },
  canvas: {
    original: {
      width: null,
      height: null,
      unit: 1
    },
    resized: {
      width: null,
      height: null,
      unit: 1
    }
  },
  crop: {
    cropX: null,
    cropY: null,
    cropW: null,
    cropH: null,
    marginT: 0,
    marginR: 0,
    marginB: 0,
    marginL: 0,
    rounded: 0
  },
  image: {
    original: {
      path: null,
      filename: null,
      width: null,
      height: null
    },
    resized: {
      src: null,
      width: null,
      height: null,
      inProgress: 0
    },
    uploadedFile: 0
  },
  thickness: {
    thickness: 0
  },
  galleryImages: []
};

const getters = {
  getGalleryImages: state => {
    return state.galleryImages || [];
  },
  getImageGalleryItems: (state, getters) => {
    const editorFiles = getters.getEditorFiles;
    const itemsIds = getters.getGalleryImages;
    const baseUrl = getters.getUrl("mediaBaseUrl");

    const items = R.filter(file => {
      if (R.indexOf(file.id, itemsIds)) return true;
      return false;
    }, editorFiles);

    return R.mapObjIndexed(item => {
      return {
        id: item.uuid,
        url: getMediaUrl(
          R.pathOr("", ["thumbnails", "thumb", "url"], item),
          baseUrl
        ),
        size: R.pathOr("", ["thumbnails", "thumb", "size"], item),
        data: item
      };
    }, items);
  },
  getMargin: state => {
    return state.margin;
  },
  getDefaultSockets: state => {
    return state.sockets;
  },
  getFormat: state => {
    return state.format;
  },
  getPOIEVariables: state => {
    return state.PoieVariables;
  },
  getEditor: state => {
    return state.editor;
  },
  getReady: state => {
    return state.ready;
  },
  getObject: state => {
    return state.object;
  },
  getCutouts: state => {
    return state.cutouts;
  },
  getSteckdosen: state => {
    return state.steckdosen;
  },
  getCanvas: state => {
    return state.canvas;
  },
  getCrop: state => {
    return state.crop;
  },
  getActiveElement: state => {
    return state.activeElement;
  },
  getThickness: state => {
    return state.thickness;
  },
  getCorners: state => {
    return state.corners;
  },
  getImage: state => {
    return state.image;
  },
  getResizedImage: state => {
    return state.image.resized.src;
  },
  //editor editor
  getEditorSize: state => {
    return {
      width: state.editor.width,
      height: state.editor.height
    };
  },
  getRotateAngle: state => {
    return state.editor.rotateAngle;
  },
  getFocalPoint: state => {
    return state.editor.focalPoint;
  },
  pdfUnit: state => {
    return state.editor.dim.imageDimByFormat.unit;
  },
  canvasFormatDimByFormat: state => {
    return {
      width: state.editor.dim.canvasFormatDimByFormat.width,
      height: state.editor.dim.canvasFormatDimByFormat.height,
      width_fix: state.editor.dim.canvasFormatDimByFormat.width_fix,
      height_fix: state.editor.dim.canvasFormatDimByFormat.height_fix,
      left: state.editor.dim.canvasFormatDimByFormat.left,
      top: state.editor.dim.canvasFormatDimByFormat.top,
      bottom: state.editor.dim.canvasFormatDimByFormat.bottom,
      right: state.editor.dim.canvasFormatDimByFormat.right
    };
  },
  canvasFormatLeft: state => {
    return state.editor.dim.canvasDimByFormat.left;
  },
  /* end editor getters */
  /*loadingEditor getters */
  getShow: state => {
    return !state.ready;
  },
  /* endLoadingEditor getters*/
  /*store getters*/
  getResizePercentage: state => {
    return {
      rW: state.image.resized.width / state.image.original.width,
      rH: state.image.resized.height / state.image.original.height
    };
  },
  getFullMargins: state => {
    return {
      width:
        state.margin.left + state.margin.right + 2 * state.thickness.thickness,
      height:
        state.margin.top + state.margin.bottom + 2 * state.thickness.thickness
    };
  },
  getData: state => {},
  getMarginsWithThickness: state => {
    return {
      left: state.margin.left + state.thickness.thickness,
      right: state.margin.right + state.thickness.thickness,
      bottom: state.margin.bottom + state.thickness.thickness,
      top: state.margin.top + state.thickness.thickness,
      type: state.margin.type,
      rand_option: state.margin.rand_option,
      color: state.margin.color,
      subtype: state.margin.subtype
    };
  },
  getFullFormatDim: state => {
    return {
      width:
        state.format.width +
        state.margin.left +
        state.margin.right +
        2 * state.thickness.thickness,
      height:
        state.format.height +
        state.margin.top +
        state.margin.bottom +
        2 * state.thickness.thickness
    };
  },
  getSplitMargins: state => {
    return {
      left: state.margin.left + state.thickness.thickness,
      right: state.margin.right + state.thickness.thickness
    };
  },
  getLayerItems: state => type => {
    /* var activeElement = null;
    
                            switch(state.activeElement.type){
                              case "objects":
                                activeElement = state.object.objects[state.activeElement.index];
                              case "steckdosen":
                                activeElement = state.steckdosen.dosens[state.activeElement.index];
                            } */

    switch (type) {
      case "objects":
        return state.object.objects;
      case "steckdosen":
        return state.steckdosen.dosens;
        break;
      case "cutouts":
        return state.cutouts.cutouts;
        break;
      default:
        return [];
    }
  },
  getLayerItemsDefaults: state => type => {
    switch (type) {
      case "objects":
        return state.object.defaults;
      case "steckdosen":
        return state.steckdosen.defaults;
      case "cutouts":
        return state.cutouts.defaults;
      default:
        return [];
    }
  },
  getActiveElement: function (state) {
    return state.activeElement;
  },
  /*end store getters*/
  /*-------------canvas gettters--------------- */
  getCanvasOriginalSize: state => {
    return state.canvas.original;
  },
  getCanvasResizedSize: state => {
    return state.canvas.resized;
  },
  /*-------------end canvas gettters--------------- */
  /*-------------crop gettters--------------- */
  getFormatPosition: state => {
    return {
      left: 20
    };
  },
  /*-------------end crop gettters--------------- */
  /*-------------format gettters--------------- */
  isRounded: state => {
    return state.format.rounded;
  },
  split: state => {
    return state.format.split;
  },
  /*-------------end format gettters--------------- */
  /*-------------image gettters--------------- */
  imagePath: state => {
    return state.image.original.path + state.image.original.filename;
  },
  originalImageSize: state => {
    return {
      width: state.image.original.width,
      height: state.image.original.height
    };
  },
  originalFilename: state => {
    return state.image.original.filename;
  },
  originalPath: state => {
    return state.image.original.path;
  },
  uploadedFile: state => {
    return state.image.uploadedFile;
  },
  /*-------------end image gettters--------------- */

  dummygetter: state => {
    return 1;
  },
  getDefaults: state => {
    return state.defaults;
  },
  getBckMode: state => {
    return state.editor.bckMode;
  },
  getMarginColor: state => {
    return state.margin.color || "#ffffff";
  }
};

const mutations = {
  changeGalleryImages: (state, galleryImages) => {
    state.galleryImages = galleryImages || [];
  },
  changeReady: (state, ready) => {
    state.ready = ready;
  },
  addToActiveElement: (state, active) => {
    state.activeElement = active;
  },
  emptyActiveElement: state => {
    state.activeElement = {
      index: 0,
      type: "main"
    };
  },
  updateItem: (state, params) => {
    const { type, index, props } = params;

    let items = [];
    switch (type) {
      case "objects":
        items = [...state.object.objects];
        items[index] = { ...items[index], ...props };
        state.object.objects = items;
        var item = state.object.objects[index];
        var deviation = {
          x: 0,
          y: 0
        };
        if (item.angle) {
          var tetha = -1 * item["angle"];
          var topleft = {
            x: (item["width"] * -1) / 2,
            y: (item["height"] * -1) / 2
          };
          var topLeftD = {
            x: topleft.x * Math.cos(tetha) - topleft.y * Math.sin(tetha),
            y: topleft.x * Math.sin(tetha) + topleft.y * Math.cos(tetha)
          };
          deviation = {
            x: topleft.x - topLeftD.x,
            y: topLeftD.y - topleft.y
          };
        }
        state.object.objects[index]["deviation"] = deviation;
        break;
      case "steckdosen":
        items = [...state.steckdosen.dosens];
        items[index] = { ...items[index], ...props };
        state.steckdosen.dosens = items;
        break;
      case "cutouts":
        items = [...state.cutouts.cutouts];
        items[index] = { ...items[index], ...props };
        state.cutouts.cutouts = items;
        break;
    }
  },
  updateZoom: (state, params) => {
    const { index, zoom } = params;
    state.object.objects[index].zoom += zoom - state.object.objects[index].zoom;
  },
  deleteObject: (state, params) => {
    const { index } = params;
    state.object.objects = R.remove(index, 1, state.object.objects);
    //state.activeElement.type = "main";
    //state.activeElement.index = 0;
    // this.commit("emptyActiveElement");
  },
  initCorners: (state, data) => {
    state.corners.corners = data;
  },
  changeCornerStatus: (state, code) => {
    state.corners.corners["corner_" + code].isActive = !(
      state.corners.corners["corner_" + code].isActive | 0
    );
  },
  changeActiveItem: (state, data) => {
    state.corners.corners["corner_" + data.corner_code].subItemIndex =
      data.index;
  },
  addObject: (state, object) => {
    state.object.objects.push(object);
  },
  changeCutout: (state, data) => {
    try {
      if (typeof data !== "object") throw "";
      if (!data.hasOwnProperty("index")) throw "";
      if (!data.hasOwnProperty("pos")) throw "";
      if (!data.hasOwnProperty("value")) throw "";
      state.cutouts.cutouts[data.index][data.pos] = data.value;
    } catch (e) {}
  },
  addNewCutout: function (state, data) {
    var POIEVariables = this.getters.getPOIEVariables;
    var left =
      (state.format.width - state.cutouts.defaults.width) / 2 +
      state.cutouts.defaults.offsetX;
    var bottom =
      (state.format.height - state.cutouts.defaults.height) / 2 +
      state.cutouts.defaults.offsetY;
    var name = state.cutouts.defaults.name;
    if (data.itemType == "rectangle") {
      name = POIEVariables.rectangleString;
    } else {
      name = POIEVariables.circleString;
    }
    state.cutouts.cutouts.push({
      elementType: "cutouts",
      type: "image",
      subtype: "cutout",
      itemType: data.itemType,
      imageSrc: "",
      left: left,
      bottom: bottom,
      width: state.cutouts.defaults.width,
      height: state.cutouts.defaults.height,
      name: name,
      offsetX: state.cutouts.defaults.offsetX,
      offsetY: state.cutouts.defaults.offsetY
    });
  },
  removeCutout: function (state, index) {
    state.cutouts.cutouts.splice(index, 1);
  },
  changeDosen: (state, data) => {
    try {
      if (typeof data !== "object") throw "";
      if (!data.hasOwnProperty("index")) throw "";
      if (!data.hasOwnProperty("pos")) throw "";
      if (!data.hasOwnProperty("value")) throw "";
      state.steckdosen.dosens[data.index][data.pos] = data.value;
    } catch (e) {}
  },
  addNewDosen: (state, data) => {
    var type = 1;
    var left = 0;
    var bottom = 0;
    var offsetx = state.steckdosen.defaults.offsetX;
    var offsety = state.steckdosen.defaults.offsetY;
    var name = state.steckdosen.defaults.name;

    if (typeof data == "object" && data.hasOwnProperty("type"))
      type = data.type;
    if (typeof data == "object" && data.hasOwnProperty("left"))
      left = data.left;
    if (typeof data == "object" && data.hasOwnProperty("bottom"))
      bottom = data.bottom;
    if (typeof data == "object" && data.hasOwnProperty("offsetx"))
      offsetx = data.offsetx;
    if (typeof data == "object" && data.hasOwnProperty("offsety"))
      offsety = data.offsety;
    if (typeof data == "object" && data.hasOwnProperty("name"))
      name = data.name;
    state.steckdosen.dosens.push({
      elementType: "steckdosen",
      type: "image",
      subtype: "dummyimage",
      code: data.code,
      imageSrc: data.imageSrc,
      left: left,
      offsetX: offsetx,
      offsetY: offsety,
      bottom: bottom,
      height: data.height,
      name: name,
      width: data.width
    });
  },
  removeDosen: (state, index) => {
    state.steckdosen.dosens.splice(index, 1);
  },
  changeMargins: (state, data) => {
    if (typeof data == "object") {
      if (data.hasOwnProperty("top") && data.top >= 0)
        state.margin.top = data.top;
      if (data.hasOwnProperty("right") && data.right >= 0)
        state.margin.right = data.right;
      if (data.hasOwnProperty("bottom") && data.bottom >= 0)
        state.margin.bottom = data.bottom;
      if (data.hasOwnProperty("left") && data.left >= 0)
        state.margin.left = data.left;
      if (data.hasOwnProperty("type")) state.margin.type = data.type;
      if (data.hasOwnProperty("lastChanged"))
        state.margin.lastChanged = data.lastChanged;
    }
  },
  changeDefaultMargin: (state, data) => {
    if (typeof data == "object") {
      if (data.hasOwnProperty("topDefault") && data.topDefault >= 0)
        state.margin.topDefault = data.topDefault;
      if (data.hasOwnProperty("rightDefault") && data.rightDefault >= 0)
        state.margin.rightDefault = data.rightDefault;
      if (data.hasOwnProperty("bottomDefault") && data.bottomDefault >= 0)
        state.margin.bottomDefault = data.bottomDefault;
      if (data.hasOwnProperty("leftDefault") && data.leftDefault >= 0)
        state.margin.leftDefault = data.leftDefault;
    }
  },
  changeMarginType: (state, type) => {
    state.margin.type = type;
  },
  changeMarginSubtype: (state, subtype) => {
    state.margin.subtype = subtype;
  },
  changeMarginColor: (state, color) => {
    state.margin.color = color;
  },
  changeRandOption: (state, value) => {
    state.margin.rand_option = value;
  },
  changeCrop: (state, crop) => {
    state.cropX = crop.cropX;
    state.cropY = crop.cropY;
    state.cropW = crop.cropW;
    state.cropH = crop.cropH;
  },
  changeMargin: (state, margin) => {
    state.marginT = margin.Top;
    state.marginR = margin.Right;
    state.marginB = margin.Bottom;
    state.marginL = margin.Left;
  },
  changeCropX: (state, cropX) => {
    state.cropX = cropX;
  },
  changeCropY: (state, cropY) => {
    state.cropY = cropY;
  },
  changeCropW: (state, cropW) => {
    state.crop.cropW = cropW;
  },
  changeCropH: (state, cropH) => {
    state.crop.cropH = cropH;
  },
  changeMarginT: (state, marginT) => {
    state.crop.marginT = marginT;
  },
  changeMarginR: (state, marginR) => {
    state.crop.marginR = marginR;
  },
  changeMarginB: (state, marginB) => {
    state.crop.marginB = marginB;
  },
  changeMarginL: (state, marginL) => {
    state.crop.marginL = marginL;
  },
  changeFormat: (state, data) => {
    if (
      typeof data == "object" &&
      data.hasOwnProperty("prop") &&
      data.hasOwnProperty("value")
    ) {
      if (state.format.hasOwnProperty(data.prop))
        state.format[data.prop] = data.value;
    }
  },
  changeRounded: (state, flag) => {
    state.format.rounded = flag;
  },
  changeSplit: (state, split) => {
    state.format.split = split;
  },
  changeEditorWidth: (state, width) => {
    state.editor.width = width;
  },
  changeEditorHeight: (state, height) => {
    state.editor.height = height;
  },
  changeImageDimByFormat: (state, dim) => {
    state.editor.dim.imageDimByFormat.height = dim.height;
    state.editor.dim.imageDimByFormat.width = dim.width;
    state.editor.dim.imageDimByFormat.width_cm = dim.width_cm;
    state.editor.dim.imageDimByFormat.height_cm = dim.height_cm;
    state.editor.dim.imageDimByFormat.unit = dim.unit;
  },
  changeCanvasDimByFormat: (state, dim) => {
    state.editor.dim.canvasDimByFormat.height = dim.height;
    state.editor.dim.canvasDimByFormat.width = dim.width;
    state.editor.dim.canvasDimByFormat.height_fix = dim.height_fix;
    state.editor.dim.canvasDimByFormat.width_fix = dim.width_fix;
    state.editor.dim.canvasDimByFormat.unit = dim.unit;
    state.editor.dim.canvasDimByFormat.top = dim.top;
    state.editor.dim.canvasDimByFormat.left = dim.left;
  },
  changeCanvasImageDimByFormat: (state, dim) => {
    state.editor.dim.canvasImageDimByFormat.height = dim.height;
    state.editor.dim.canvasImageDimByFormat.width = dim.width;
    state.editor.dim.canvasImageDimByFormat.left = dim.left;
    state.editor.dim.canvasImageDimByFormat.top = dim.top;
    state.editor.dim.canvasImageDimByFormat.right = dim.right;
    state.editor.dim.canvasImageDimByFormat.bottom = dim.bottom;
  },
  changeCanvasFormatDimByFormat: (state, dim) => {
    state.editor.dim.canvasFormatDimByFormat.height = dim.height;
    state.editor.dim.canvasFormatDimByFormat.width = dim.width;
    state.editor.dim.canvasFormatDimByFormat.height_fix = dim.height_fix;
    state.editor.dim.canvasFormatDimByFormat.width_fix = dim.width_fix;
    state.editor.dim.canvasFormatDimByFormat.left = dim.left;
    state.editor.dim.canvasFormatDimByFormat.top = dim.top;
    state.editor.dim.canvasFormatDimByFormat.bottom = dim.bottom;
    state.editor.dim.canvasFormatDimByFormat.right = dim.right;
  },
  changeCanvasFormatPositionByFormat: (state, dim) => {
    state.editor.dim.canvasFormatDimByFormat.left = dim.left;
    state.editor.dim.canvasFormatDimByFormat.top = dim.top;
    state.editor.dim.canvasFormatDimByFormat.bottom = dim.bottom;
    state.editor.dim.canvasFormatDimByFormat.right = dim.right;
  },
  changeMarginView: (state, flag) => {
    state.editor.marginView = flag;
  },
  increaseRotateAngle: state => {
    state.editor.rotateAngle = (state.rotateAngle + 90) % 360;
  },
  changeRotateAngle: (state, angle) => {
    state.editor.rotateAngle = angle;
  },
  changeZoom: (state, zoom) => {
    state.editor.zoom = zoom;
  },
  changeCropMode: (state, mode) => {
    state.editor.cropMode = mode;
  },
  changeBckMode: (state, mode) => {
    state.editor.bckMode = mode;
  },
  changeFocalPoint: (state, point) => {
    if (typeof point == "object") {
      if (point.hasOwnProperty("x")) state.editor.focalPoint.x = point.x;
      if (point.hasOwnProperty("y")) state.editor.focalPoint.y = point.y;
    }
  },
  changeImageId: (state, imageId) => {
    state.image.original.imageId = imageId;
  },
  changeOriginalImageSize: (state, size) => {
    state.image.original.width = size.width;
    state.image.original.height = size.height;
  },
  changeOriginalImageWidth: (state, width) => {
    state.image.original.width = width;
  },
  changeOriginalImageHeight: (state, height) => {
    state.image.original.height = height;
  },
  changeResizedImageSrc: (state, src) => {
    state.image.resized.src = src;
  },
  changeResizedImageWidth: (state, width) => {
    state.image.resized.width = width;
  },
  changeResizedImageHeight: (state, height) => {
    state.image.resized.height = height;
  },
  changeResizedImageSize: (state, size) => {
    state.image.resized.width = size.width;
    state.image.resized.height = size.height;
  },
  inProgress: (state, value) => {
    state.image.resized.inProgress = value;
  },
  changeUploadedFile: (state, value) => {
    state.image.uploadedFile = value;
  },
  changeThickness: (state, thickness) => {
    state.thickness.thickness = thickness;
  },
  getResizeImage: (state, data) => {},
  changeCheckMonochromatic: (state, data) => {
    state.defaults.check_monochromatic = data;
  },
  initImageEditorData: (state, data) => {
    if (data.corners) {
      state.corners.corners = data.corners;
    }
    if (data.sockets) {
      state.sockets = data.corners;
    }
  }
};

const actions = {
  loadImageEditorData: ({ commit, getters }, payload) => {
    if (R.hasPath(["Texts"], payload))
      state.PoieVariables.Texts = {
        ...state.PoieVariables.Texts,
        ...payload.Texts
      };
    if (R.hasPath(["cmToInch"], payload))
      state.PoieVariables.cmToInch = payload.cmToInch;
    if (R.hasPath(["corners"], payload))
      state.corners.corners = payload.corners;
    if (R.hasPath(["defaults"], payload))
      state.PoieVariables.defaults = payload.defaults;
    if (R.hasPath(["dosenFullHeight"], payload))
      state.PoieVariables.dosenFullHeight = payload.dosenFullHeight;
    if (R.hasPath(["dosenFullWidth"], payload))
      state.PoieVariables.dosenFullWidth = payload.dosenFullWidth;
    if (R.hasPath(["dosenIconSizes"], payload))
      state.PoieVariables.dosenIconSizes = payload.dosenIconSizes;
    if (R.hasPath(["dosenSizes"], payload))
      state.PoieVariables.dosenSizes = payload.dosenSizes;
    if (R.hasPath(["enableCorners"], payload))
      state.PoieVariables.enableCorners = parseInt(payload.enableCorners);
    if (R.hasPath(["enableCutouts"], payload))
      state.PoieVariables.enableCutouts = parseInt(payload.enableCutouts);
    if (R.hasPath(["enableSteckdosen"], payload))
      state.PoieVariables.enableSteckdosen = parseInt(payload.enableSteckdosen);
    if (R.hasPath(["ppiQuality"], payload))
      state.PoieVariables.ppiQuality = payload.ppiQuality;
    if (R.hasPath(["pxToPt"], payload))
      state.PoieVariables.pxToPt = payload.pxToPt;
    if (R.hasPath(["sockets"], payload))
      state.sockets = {
        ...state.sockets,
        ...payload.sockets
      };
    if (R.hasPath(["splitOiePdf"], payload))
      state.PoieVariables.splitOiePdf = parseInt(payload.splitOiePdf);
    if (R.hasPath(["steckdosenLimits"], payload))
      state.PoieVariables.steckdosenLimits = {
        ...state.PoieVariables.steckdosenLimits,
        ...payload.steckdosenLimits
      };

    const imageGallery = R.pathOr([], ["galleryImages"], payload);

    if (!R.isEmpty(imageGallery)) {
      commit("changeGalleryImages", imageGallery);
      const workingsData = imageGallery.map(uuid => {
        return {
          id: uuid
        };
      });

      axios.instance
        .post(getters.getUrl("workingsUrl"), {
          data: workingsData
        })
        .then(response => {
          const { success, data } = response.data;
          if (success) {
            R.forEach(item => {
              const { success, data } = item;
              if (success) {
                commit("addEditorFile", data);
              }
            }, data);
          }
        })
        .catch(error => {
          console.log("Error " + error);
        });
    }
  },
  completePersonalization: (
    { commit, getters, rootState, dispatch },
    payload
  ) => {
    var additional_data = payload.onCartDataEncoded;
    var url = getters.getUrl(axios.apiGetCompletePersonalization);
    commit("setPersonalizeLoading", true);
    var selectionId = getters.getSelectionId;
    const _data = {
      template_id: 0,
      attached: 1,
      session: getters.getCustomer,
      source: "lfp",
      project_data: {
        content: JSON.stringify(getters.getAddToCartCallbacks[0]())
      },
      store_id: getters.getStoreCode,
      store_code: getters.getStoreCode,
      product_id: getters.getWebProductId,
      api_url: "/",
      api_template_id: 0,
      additional_data: additional_data,
      success_url: "",
      selection: selectionId,
      customer: getters.getCustomer,
      preview: { 0: getters.getResizedImage }
    };
    axios.instance
      .post(url, _data)
      .then(response => {
        const { success, data, customizedProductId } = response.data;
        if (success) {
          payload.callbackFucntion(payload.onCartData);
        } else {
          alert(response.message);
        }
        commit("setPersonalizeLoading", false);
      })
      .catch(error => {
        console.log("Error " + error);
        commit("setPersonalizeLoading", false);
      });
  },
  addNewCutout: (context, data) => {
    context.commit("addNewCutout", data);
    context.dispatch("updateCutoutsNumber");
  },
  removeCutout: (context, index) => {
    context.commit("removeCutout", index);
    context.dispatch("updateCutoutsNumber");
  },
  updateCutoutsNumber: context => {
    try {
      var formElement = document.getElementById("product_addtocart_form");
      var cutoutsQtyElement = document.getElementById("cutouts_qty");

      if (!formElement) throw false;
      if (!cutoutsQtyElement) {
        var cutoutsQtyElement = document.createElement("input");
        cutoutsQtyElement.type = "hidden";
        cutoutsQtyElement.name = "print_options[cutouts_qty]";
        cutoutsQtyElement.id = "cutouts_qty";
        formElement.appendChild(cutoutsQtyElement);
      }

      cutoutsQtyElement.value = context.state.cutouts.length;
    } catch (e) {}
  },
  addNewDosen: (context, data) => {
    context.commit("addNewDosen", data);
    context.dispatch("updateDosenNumber");
  },
  removeDosen: (context, index) => {
    context.commit("removeDosen", index);
    context.dispatch("updateDosenNumber");
  },
  updateDosenNumber: context => {
    try {
      var formElement = document.getElementById("product_addtocart_form");
      var steckdosenQtyElement = document.getElementById("steckdosen_qty");

      if (!formElement) throw false;
      if (!steckdosenQtyElement) {
        var steckdosenQtyElement = document.createElement("input");
        steckdosenQtyElement.type = "hidden";
        steckdosenQtyElement.name = "print_options[steckdosen_qty]";
        steckdosenQtyElement.id = "steckdosen_qty";
        formElement.appendChild(steckdosenQtyElement);
      }

      steckdosenQtyElement.value = context.state.dosens.length;
    } catch (e) {}
  },
  changeCanvasSize: (state, data) => {
    if (typeof data == "object" && data.hasOwnProperty("type")) {
      if (state.canvas.hasOwnProperty(data.type)) {
        state.canvas[data.type].width = data.width;
        state.canvas[data.type].height = data.height;
      }
    }
  },
  changeCanvasOriginalUnit: (state, unit) => {
    state.canvas.original.unit = unit;
  },
  changeCanvasResizedUnit: (state, unit) => {
    state.canvas.resized.unit = unit;
  },
  doPortret: function (_ref, { widget }) {
    var commit = _ref.commit;
    var width = _ref.getters.getFormat.width;
    var height = _ref.getters.getFormat.height;
    _ref.dispatch("inputCustomFormat", {
      width: Math.min(width, height),
      height: Math.max(width, height),
      widget
    });
  },
  doLandscape: (_ref, { widget }) => {
    var commit = _ref.commit;
    var width = _ref.getters.getFormat.width;
    var height = _ref.getters.getFormat.height;
    _ref.dispatch("inputCustomFormat", {
      width: Math.max(width, height),
      height: Math.min(width, height),
      widget
    });
  },
  doChangeFormat: (_ref, params) => {
    var commit = _ref.commit;
    var POIEVariables = _ref.getters.getPOIEVariables;
    var width = params.width;
    var height = params.height;
    width = parseFloat(width);
    height = parseFloat(height);
    commit("changeFormat", {
      prop: "width",
      value: width
    });
    commit("changeFormat", {
      prop: "height",
      value: height
    });

    /* for (
      var index = 0;
      index <= _ref.getters.getSteckdosen.dosens.length - 1;
      index++
    ) {
      var value = _ref.getters.getSteckdosen.dosens[index].posx;
      var type = _ref.getters.getSteckdosen.dosens[index].type - 1;
      var size = _ref.getters.getSteckdosen.dosens[index].size;
      var fullWidth = POIEVariables.dosenFullWidth[type];
      var right = POIEVariables.steckdosenLimits[type][1] - size / 2;
      var width = _ref.getters.getFormat.width;
      var height = _ref.getters.getFormat.height;
      var maxX = parseFloat((width - fullWidth + size / 2 - right).toFixed(2));
      var left = POIEVariables.steckdosenLimits[type][3];
      if (value < left) {
        commit("changeDosen", {
          index: index,
          pos: "posx",
          value: left
        });
      }
      if (value > maxX) {
        commit("changeDosen", {
          index: index,
          pos: "posx",
          value: maxX
        });
      }
      var value = _ref.getters.getSteckdosen.dosens[index].posy;
      var type = _ref.getters.getSteckdosen.dosens[index].type - 1;
      var size = _ref.getters.getSteckdosen.dosens[index].size;
      var fullHeight = POIEVariables.dosenFullHeight[type];
      var top = POIEVariables.steckdosenLimits[type][0] - size / 2;
      var height = _ref.getters.getFormat.height;
      var maxY = parseFloat((height - fullHeight + size / 2 - top).toFixed(2));
      var bottom = POIEVariables.steckdosenLimits[type][2];
      if (value < bottom) {
        commit("changeDosen", {
          index: index,
          pos: "posy",
          value: bottom
        });
      }
      if (value > maxY) {
        commit("changeDosen", {
          index: index,
          pos: "posy",
          value: maxY
        });
      }
    } */
  },
  changeCropMode: function (_ref, mode) {
    var commit = _ref.commit;
    commit("changeCropMode", mode);
    if (mode) {
      this.dispatch("activateBgDrag", {});
    }
  },
  changeBckMode: (_ref, mode) => {
    var commit = _ref.commit;
    commit("changeBckMode", mode);
  },
  initEditor: function (context, data) {
    var commit = context.commit;
    var getters = context.getters;
    var image = getters.getImage;
    commit("changeReady", 0);
    this.dispatch("setEditorDim", {});
    var data = {
      uuid: getters.getImage.original.imageId,
      background: 1
    };
    this.dispatch("getResizedImage", data);
  },
  setEditorDim: function (context, data) {
    var commit = context.commit;
    var getters = context.getters;
    const o = getters.getDefaults;
    var editor = jQuery(o.editor);
    commit("changeEditorWidth", editor.width());
    commit("changeEditorHeight", editor.height());
  },
  getResizedImage: function (context, data) {
    var commit = context.commit;
    var getters = context.getters;
    var image = getters.getImage;
    var POIEVariables = getters.getPOIEVariables;
    if (!image.resized.inProgess) {
      commit("inProgress", 1);
      commit("changeReady", 0);

      const cache = context.getters.findEditorFiles(data.uuid);

      if (!cache) {
        axios.instance
          .post(
            getters.getUrl("getResizedImageUrl") + data.uuid,
            qs.stringify({})
          )
          .then(result => {
            commit("inProgress", 0);
            var response = result.data;
            if (response.success) {
              this.commit("addEditorFile", response.data);
              if (typeof data.background != "undefined" && data.background) {
                this.dispatch("addImageToBackground", {
                  data,
                  result: response.data
                });
              } else {
                this.dispatch("addObjectOnCanvas", {
                  data,
                  result: response.data
                });
              }
            } else {
              alert(response.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        if (typeof data.background != "undefined" && data.background) {
          context.dispatch("addImageToBackground", {
            data,
            result: cache
          });
        } else {
          context.dispatch("addObjectOnCanvas", {
            data,
            result: cache
          });
        }
      }
    }
  },
  addObjectOnCanvas: function ({ commit, getters }, { result, data }) {
    var editor = getters.getEditor;
    var POIEVariables = getters.getPOIEVariables;
    var widthLayer = jQuery("#format-layer").width();
    var heightLayer = jQuery("#format-layer").height();
    var localWidth = 0;
    var localHeight = 0;
    var imageUnit = editor.dim.imageDimByFormat.unit;
    var canvasUnit = editor.dim.canvasDimByFormat.unit;
    var unit = imageUnit / canvasUnit;
    var imageRatio =
      result.thumbnails.working.size.height /
      result.thumbnails.working.size.width;
    if (widthLayer > heightLayer) {
      localWidth = parseInt(heightLayer / 3);
      localHeight = localWidth * imageRatio;
    } else {
      localHeight = parseInt(widthLayer / 3);
      localWidth = localHeight * imageRatio;
    }
    var params = {
      uuid: data.uuid,
      type: "image",
      subtype: "cropimage",
      width: localWidth / unit, //cm
      height: localHeight / unit, //cm
      left: data.left,
      bottom: data.top,
      imageSrc: getMediaUrl(
        result.thumbnails.working.url,
        getters.getUrl("mediaBaseUrl")
      ),
      ratio: localWidth / localHeight,
      ratioImage: imageRatio,
      ratioWidth: result.size.width / result.thumbnails.working.size.width,
      ratioHeight: result.size.height / result.thumbnails.working.size.height,
      file_type: result.file_type,
      rotateAngle: 0,
      angle: 0,
      offsetX: 0,
      hasSnap: 1,
      offsetY: 0,
      zoom: 0,
      scaleX: 1
    };
    commit("addObject", params);
    commit("changeReady", 1);
  },
  addImageToBackground: function (context, { result }) {
    var getters = context.getters;
    var commit = context.commit;
    var POIEVariables = getters.getPOIEVariables;
    var image_src = getMediaUrl(
      result.thumbnails.working.url,
      getters.getUrl("mediaBaseUrl")
    );
    commit("changeUploadedFile", 1);
    commit("changeOriginalImageSize", result.size);
    commit("changeResizedImageSize", result.thumbnails.working.size);
    commit("changeResizedImageSrc", image_src);
    commit("changeImageId", result.uuid);
    this.dispatch("setEditorDim", {});
    commit("changeReady", 1);
  },
  activateBgDrag: function (context) {
    var getters = context.getters;
    var o = getters.getDefaults;
    var imageLayer = jQuery(o.imageLayer);

    if (imageLayer.length) {
      var bgDraggable = imageLayer.data("printqBgDraggable");
      var editor = getters.getEditor;
      if (!bgDraggable) {
        imageLayer.bgDraggable({
          drag: (function (that) {
            return function (event, ui) {
              var zoom = editor.zoom / 100; //cache this somewhere
              that.dispatch("storeFocalPoint", { ui, zoom });
            };
          })(this),
          stop: (function (that) {
            return function (event, ui) {
              var zoom = editor.zoom / 100; //cache this somewhere
              that.dispatch("storeFocalPoint", { ui, zoom });
            };
          })(this)
        });
      }
    }
  },
  updateBgOnResize: function (context, data) {
    var o = context.getters.getDefaults;
    var imageLayer = jQuery(o.imageLayer);

    if (imageLayer.length) {
      var bgDraggable = imageLayer.data("printqBgDraggable");
      if (bgDraggable) {
        var ui = imageLayer.bgDraggable("updateOnResize");
        if (ui) {
          var zoom = context.getters.getEditor.zoom / 100; //cache this somewhere
          this.dispatch("storeFocalPoint", { ui, zoom });
        }
      }
    }
  },
  storeFocalPoint: function (context, { ui, zoom }) {
    var commit = context.commit;
    var x = (ui.bgPosition.left * -1 + ui.elementSize.width / 2) / zoom;
    var y = (ui.bgPosition.top * -1 + ui.elementSize.height / 2) / zoom;
    var point = {
      x: x,
      y: y
    };

    commit("changeFocalPoint", point);
  },
  parseChangeOptionResponse: function (context, data) {
    var rootGetters = context.rootGetters;
    var commit = context.commit;
    var getters = context.getters;
    var pageOptions = rootGetters.getActiveProductPageOptions;
    var margin = rootGetters.getActiveProductPageOptions;
    var o = getters.getDefaults;
    R.forEachObjIndexed(
      (function (that, rootGetters, o, commit) {
        return function (_option, _part) {
          if (_part == "format") {
            var selectedFormat = _option["selected"][0];
            var format_type = selectedFormat.split("custom_")[1];
            if (typeof format_type == "string") {
              var customValues = format_type.split("_");
              if (customValues.length == 2) {
                that.dispatch("doChangeFormat", {
                  width: parseFloat(customValues[0]),
                  height: parseFloat(customValues[1])
                });
              }
            } else {
              if (typeof _option.values != "undefined") {
                R.forEach(
                  (function (that, selectedFormat) {
                    return function (format) {
                      if (format["value"] == selectedFormat) {
                        that.dispatch("doChangeFormat", {
                          width: parseFloat(format["attributes"]["width"]),
                          height: parseFloat(format["attributes"]["height"])
                        });
                      }
                    };
                  })(that, selectedFormat),
                  _option["values"]
                );
              }
            }
          }
          var _value = _option["selected"][0];
          var margin_type = _value.split("oie_margin_type_")[1];
          if (typeof margin_type == "string") {
            var monochromatic_container = jQuery(
              o.monochromatic_container
            ).hide();
            var rounded_container = jQuery(o.rounded_container);
            commit("changeCheckMonochromatic", 0);
            if (
              that.getters.getFormat.width == that.getters.getFormat.height &&
              margin_type != "mirrored"
            ) {
              rounded_container.show();
            } else {
              commit("changeRounded", 0);
              jQuery(o.is_rotated_input).attr("checked", false);
              rounded_container.hide();
            }
            switch (margin_type) {
              case "enlarged":
                commit("changeMarginType", -1);
                commit("changeRandOption", 0);
                break;
              case "mirrored":
                commit("changeMarginSubtype", 1);
                commit("changeMarginType", 1);
                commit("changeRandOption", 0);
                break;
              case "white":
                commit("changeMarginSubtype", 2);
                commit("changeMarginType", 1);
                commit("changeMarginColor", "#ffffff");
                commit("changeRandOption", 1);
                break;
              case "monochromatic":
                commit("changeMarginSubtype", 3);
                commit("changeMarginType", 1);
                commit("changeCheckMonochromatic", 1);
                monochromatic_container.show();
                var monochromatic_input = jQuery(o.monochromatic_input);
                commit("changeMarginColor", monochromatic_input.val());
                commit("changeRandOption", 0);
                break;
            }
          }
          var margin_thickness = _value.split("oie_margin_thickness_")[1];
          if (typeof margin_thickness == "string") {
            margin_thickness = margin_thickness.replace("_", ".");
            margin_thickness = parseFloat(margin_thickness);
            if (!isNaN(margin_thickness))
              commit("changeMargins", {
                top: margin_thickness,
                right: margin_thickness,
                bottom: margin_thickness,
                left: margin_thickness
              });
          }
          //check for thickness
          var thickness = _value.split("oie_thickness_")[1];
          if (typeof thickness == "string") {
            thickness = thickness.replace("_", ".");
            thickness = parseFloat(thickness);
            if (!isNaN(thickness)) commit("changeThickness", thickness);
          }
        };
      })(this, rootGetters, o, commit),
      pageOptions
    );
  },
  initFormatPep: function (context, data) {
    var o = context.getters.getDefaults;
    var format = jQuery(o.format);
    var commit = context.commit;
    format
      .pep({
        constrainTo: "#oie-canvas",
        shouldEase: false,
        useCSSTranslation: false,
        useBoundingClientRect: true,
        shouldPreventDefault: false,
        start: (function (o) {
          return function () {
            var formatCropLayer = jQuery(o.formatCropLayer);
            formatCropLayer.addClass("invisibleBg");
          };
        })(o),
        drag: (function (o, that, commit) {
          return function (ev, pep) {
            var formatLayer = pep.$el;
            var top = Math.round(parseFloat(formatLayer.css("top")));
            var left = Math.round(parseFloat(formatLayer.css("left")));
            var bottom = Math.round(parseFloat(formatLayer.css("bottom")));
            var right = Math.round(parseFloat(formatLayer.css("right")));

            if (isNaN(top)) {
              top = 0;
            }
            if (isNaN(left)) {
              left = 0;
            }
            if (isNaN(bottom)) {
              bottom = 0;
            }
            if (isNaN(right)) {
              right = 0;
            }

            commit("changeCanvasFormatPositionByFormat", {
              top: top,
              left: left,
              bottom: bottom,
              right: right
            });
            that.dispatch("updateBgOnResize");
          };
        })(o, this, commit),
        stop: (function (o, commit) {
          return function (ev, pep) {
            var formatLayer = pep.$el;
            const top = Math.round(parseFloat(formatLayer.css("top")));
            const left = Math.round(parseFloat(formatLayer.css("left")));
            const bottom = Math.round(parseFloat(formatLayer.css("bottom")));
            const right = Math.round(parseFloat(formatLayer.css("right")));
            commit("changeCanvasFormatPositionByFormat", {
              top: top,
              left: left,
              bottom: bottom,
              right: right
            });
            var formatCropLayer = $(o.formatCropLayer);
            formatCropLayer.removeClass("invisibleBg");
          };
        })(o, commit)
      })
      .css(context.getters.getFormatPosition);
  },
  initSteckDosenClicks: function (context, data) {
    var options = context.getters.getDefaults;
    jQuery("#format-layer").droppable({
      accepts: ".steckdosen_item_draggable,.imageItem",
      drop: (function (context, that) {
        return function (event, ui) {
          var data = ui.draggable.data();
          if (ui.draggable.hasClass("steckdosen_item_draggable")) {
            var offset = jQuery("#format-layer").offset();
            var imageUnit = context.getters.getEditor.dim.imageDimByFormat.unit;
            var canvasUnit =
              context.getters.getEditor.dim.canvasDimByFormat.unit;
            var unit = imageUnit / canvasUnit;
            if (
              jQuery("#format-layer").height() <
              ui.position.top - offset.top + ui.helper.height()
            ) {
              ui.position.top =
                jQuery("#format-layer").height() -
                ui.helper.height() +
                offset.top;
            }
            if (ui.position.top < offset.top) {
              ui.position.top = offset.top;
            }
            if (ui.position.left < offset.left) {
              ui.position.left = offset.left;
            }
            if (
              jQuery("#format-layer").width() <
              ui.position.left - offset.left + ui.draggable.width()
            ) {
              ui.position.left =
                jQuery("#format-layer").width() -
                ui.helper.width() +
                offset.left;
            }
            var posx = (ui.position.left - offset.left) / unit;
            var posy =
              (jQuery("#format-layer").height() -
                ui.helper.height() -
                (ui.position.top - offset.top)) /
              unit;
            var info = data.info;
            context.commit("addNewDosen", {
              code: info.code,
              name: info.name,
              imageSrc: info.image_url,
              width: info.width,
              height: info.height,
              offsetx: parseFloat(info.offsetx),
              offsety: parseFloat(info.offsety),
              left: posx,
              bottom: posy
            });
          }
          if (ui.draggable.hasClass("imageItem")) {
            var offset = jQuery("#format-layer").offset();
            var imageUnit = context.getters.getEditor.dim.imageDimByFormat.unit;
            var canvasUnit =
              context.getters.getEditor.dim.canvasDimByFormat.unit;
            var unit = imageUnit / canvasUnit;
            if (
              jQuery("#format-layer").height() <
              ui.position.top - offset.top + ui.helper.height()
            ) {
              ui.position.top =
                jQuery("#format-layer").height() -
                ui.helper.height() +
                offset.top;
            }
            if (ui.position.top < offset.top) {
              ui.position.top = offset.top;
            }
            if (ui.position.left < offset.left) {
              ui.position.left = offset.left;
            }
            if (
              jQuery("#format-layer").width() <
              ui.position.left - offset.left + ui.draggable.width()
            ) {
              ui.position.left =
                jQuery("#format-layer").width() -
                ui.helper.width() +
                offset.left;
            }
            var posx = (ui.position.left - offset.left) / unit;
            var posy =
              (jQuery("#format-layer").height() -
                ui.helper.height() -
                (ui.position.top - offset.top)) /
              unit;
            var image = data.image;
            var dataToSend = {
              uuid: image.uuid,
              left: posx,
              top: posy,
              background: context.getters.getEditor.bckMode | 0
            };
            that.dispatch(getResizedImage, dataToSend);
          }
        };
      })(context, this)
    });
    jQuery("body").on("mouseup", function () {
      var format = jQuery("#format-layer");
      if (format.length) {
        if (format.data("plugin_pep") != "undefined") {
          var data = format.data("plugin_pep");
          data.disableMove = false;
          format.data("plugin_pep", data);
        }
      }
    });
  },
  initImageEditorData: function (context, data) {
    context.commit("initImageEditorData", data);
  },
  checkItemPosition: function ({ commit, getters }, data) {
    const objects = getters.getObject.objects;
    const stekdosens = getters.getSteckdosen.dosens;
    const cutouts = getters.getCutouts.cutouts;
    const format = getters.getFormat;

    objects.forEach((item, index) => {
      computeNewPositionforItem(item, "objects", index, format, commit);
    });
    stekdosens.forEach((item, index) => {
      computeNewPositionforItem(item, "steckdosen", index, format, commit);
    });
    cutouts.forEach((item, index) => {
      computeNewPositionforItem(item, "cutouts", index, format, commit);
    });
  }
};

function computeNewPositionforItem(item, type, index, format, commit) {
  const { width, height, bottom, left, offsetX, offsetY } = item;
  const topDiff =
    format.height - (bottom + parseFloat(height) - parseFloat(offsetY));
  const leftDiff =
    format.width - (left + parseFloat(width) - parseFloat(offsetX));
  let newBottom = bottom;
  let newLeft = left;
  if (topDiff < 0) {
    newBottom = bottom + topDiff;
    if (newBottom < 0) newBottom = 0;
  }
  if (leftDiff < 0) {
    newLeft = left + leftDiff;
    if (newLeft < 0) newLeft = 0;
  }

  if (newBottom != bottom || newLeft != left) {
    const data = {
      bottom: newBottom,
      left: newLeft
    };
    commit("updateItem", {
      type: type,
      index: index,
      props: data
    });
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};
